import { Component, ErrorHandler, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-consultancygrid',
  templateUrl: './consultancygrid.component.html',
  styleUrls: ['./consultancygrid.component.css']
})
export class ConsultancygridComponent implements OnInit {
title="Consultancy Details";
dtOptions: any = {};
ConsultancyList: any[] = [];
mode: any;
@ViewChild(DataTableDirective)
datatableElement: DataTableDirective;
isSearch: boolean;
data: any;
dtTrigger: Subject<any> = new Subject();
@ViewChild(DataTableDirective) dtElement: DataTableDirective;

constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

ngOnInit(): void {
  this.GetAllConsultancy();
  $(document).ready(function () {
    //$('[data-toggle="tooltip"]').tooltip();
  });
  this.dtOptions = {

    dom: 'lBfrtip',
    lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
    scroll: "250px",
    select: true,
    buttons: [
      {
        extend: 'collection',
        text: 'Export',
        className: 'btn btn-radius',
        buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
      },
      { extend: 'colvis', text: 'Column Visibility', className: 'btn btn-radius' }
    ],
  }
}

GetAllConsultancy() {
  debugger;
  this.data = this.userService.GetAllConsultancy();
  this.data.subscribe((Response: any) => {
    this.ConsultancyList = Response.Result;
    this.rerender();
  }, (error) => {
    if (error.status == 401 || error.status == 500) {
      this.errorHandler.handleError(error);
    }
    else if (error.status == 400) {
      swal('Warning!', error.error.Message, 'warning');
    }
  });
}

/*for Datatable*/
ngAfterViewInit(): void {
  this.dtTrigger.next();
}


ngOnDestroy(): void {
  this.dtTrigger.unsubscribe();
}

rerender(): void {
  try {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
    });
    this.dtTrigger.next();
  } catch (err) {
    console.log(err);
  }
}
}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/consultancy/consultancygrid/consultancygrid.component.ts